var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M8 16L16 8","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-dasharray":"6 3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }